<section class="app-rew">
  <div class="container app-rew__con">
    <h2
      [appAnimate]="'fadeInRight'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
      class="app-rew__con--h2 app-title navy-blue text-center"
    >
      Pula nagród <br class="d-none d-sm-none" />w Loterii Foxy
    </h2>

    <img
      ngSrc="assets/images/rewards/prize-pool@2x.webp"
      alt="310 000 zł"
      height="358"
      width="1103"
      priority="false"
      class="app-rew__con--prize-pool"
      [appAnimate]="'bounceInUp'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
    />

    <img
      ngSrc="assets/images/rewards/reward-ornament-1.webp"
      alt="reward ornaments"
      width="747"
      height="692"
      priority="false"
      class="app-rew__con--ornament-1"
      [appAnimate]="'fadeIn'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
    />

    <img
      ngSrc="assets/images/rewards/reward-ornament-2.webp"
      alt="reward ornaments"
      width="248"
      height="231"
      priority="false"
      class="app-rew__con--ornament-2"
      [appAnimate]="'fadeIn'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
    />

    <div class="app-rew__con__wr">
      <p
        class="app-rew__con__wr--p"
        [appAnimate]="'bounceInUp'"
        [aos]="0.2"
        [once]="true"
      >
        CODZIENNIE DO WYGRANIA
      </p>

      <ul class="app-rew__con__wr__ul">
        <li
          [appAnimate]="'bounceInUp'"
          [aos]="0.2"
          [once]="true"
          [delay]="'100'"
        >
          <span>27x</span>
          <img
            ngSrc="assets/images/rewards/100_PLN.webp"
            alt="100 zł"
            width="79"
            height="81"
            priority="false"
          />
        </li>
        <li
          [appAnimate]="'bounceInUp'"
          [aos]="0.2"
          [once]="true"
          [delay]="'200'"
        >
          <span>4x</span>
          <img
            ngSrc="assets/images/rewards/200_PLN.webp"
            alt="200 zł"
            width="79"
            height="81"
            priority="false"
          />
        </li>
        <li
          [appAnimate]="'bounceInUp'"
          [aos]="0.2"
          [once]="true"
          [delay]="'300'"
        >
          <span>1x</span>
          <img
            ngSrc="assets/images/rewards/500_PLN.webp"
            alt="500 zł"
            width="79"
            height="81"
            priority="false"
          />
        </li>
        <li
          [appAnimate]="'bounceInUp'"
          [aos]="0.2"
          [once]="true"
          [delay]="'400'"
        >
          <span>1x</span>
          <img
            ngSrc="assets/images/rewards/1000_PLN.webp"
            alt="1000 zł"
            width="79"
            height="81"
            priority="false"
          />
        </li>
      </ul>

      <p class="app-rew__con__wr--p d-block d-lg-none px-5">
        Nagrody przyznawane w&nbsp;formie <br />czek BLIK - do wypłaty w każdym
        bankomacie.
      </p>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="476.802"
        height="145.267"
        viewBox="0 0 476.802 145.267"
        class="app-rew__con__wr__svg d-none d-lg-block"
        [appAnimate]="'fadeIn'"
        [aos]="0.2"
        [once]="true"
      >
        <g transform="translate(-315.29 -1261)">
          <text
            transform="translate(366.29 1313.634)"
            fill="#fff"
            font-size="20"
            font-weight="500"
          >
            <tspan x="0" y="0">Nagrody przyznawane w formie</tspan>
            <tspan x="0" y="28">Czek BLIK - do wypłaty w każdym</tspan>
            <tspan x="0" y="56">bankomacie.</tspan>
          </text>
          <path
            d="M163.634,144.768A72.134,72.134,0,1,1,163.634.5H443.1a72.16,72.16,0,0,1,67.328,46.191A92.52,92.52,0,0,0,526.893,49.5c25.214,1.789,40.027-11.584,40.027-11.584s-6.208,24.859-37.494,31.439a131.135,131.135,0,0,1-14.2,2.142c.006.378.009.76.009,1.139A72.133,72.133,0,0,1,443.1,144.768Z"
            transform="translate(224.29 1261)"
            fill="none"
            stroke="#fff"
            stroke-width="1"
            stroke-dasharray="5"
          />
        </g>
      </svg>
    </div>
  </div>
</section>
